import { Component, Host, h, Listen, Prop, Element } from '@stencil/core';
import { isPlatform } from '@baloise/ds-core';

@Component({
  tag: 'bam-gallery-slider',
  styleUrl: 'bam-gallery-slider.scss',
})
export class BamGallerySlider {
  @Element() el: HTMLElement;
  @Prop() hasControls?: boolean = true;

  @Listen('resize', { target: 'window' })
  handleResize() {
    this.setControls();
  }

  componentDidLoad() {
    this.setControls();
  }

  setControls = () => {
    if(!isPlatform('touch') && this.hasControls) {
      this.el.querySelector('bal-carousel').controls = 'large'
    } else {
      this.el.querySelector('bal-carousel').controls = 'none'
    }
  }

  render() {
    return (
      <Host>
        <div class="container">
          <div class="grid is-multiline is-overflow-hidden">
            <slot name="column-one"></slot>
            <div class="col tablet:is-full desktop:is-two-thirds is-shadow-left">
              <div>
                <slot name="bal-carousel-items"></slot>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
